import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import request from 'superagent';

import Input from './Input';

const APPLE = 'apple';
const ANDROID = 'android';
const APPLE_URL = '/v1/external-app-store/apple-store-load';
const ANDROID_URL = '/v1/external-app-store/google-play-load';

export default class AppStoreIcon extends PureComponent {
  static defaultProps = {
    message: 'Unable to find app',
    className: '',
    imageClassName: ''
  };

  static propTypes = {
    /**
     * app Id that is used to reference the app in apple store or android play store
     * Or this could be a url
     * If its a url and the request to external app store doesn't fetch any data,
     * the url is displayed as is
     */
    appId: PropTypes.string,

    /**
     * Indicates whetehr the store to request is apple store or android play store
     */
    store: PropTypes.oneOf([APPLE, ANDROID]).isRequired,

    /**
     * Default message to be displayed if app can not be found in the store
     */
    message: PropTypes.string,

    /**
     * className to be applied on the component
     */
    className: PropTypes.string,

    /**
     * className to be applied on img tag
     */
    imageClassName: PropTypes.string,

    /**
     * data-testid to be used for testing
     */
    testid: PropTypes.string
  };

  constructor(props) {
    super(props);

    this.state = {
      error: false,
      image: null,
      text: null
    };
  }

  /**
   * Makes a request to the external app store
   * Sets image and text on component's state based on the response
   */
  componentDidMount() {
    const appId =
      this.props.store === APPLE
        ? /[0-9]+/g.exec(this.props.appId)
        : this.props.appId;
    const url = this.props.store === APPLE ? APPLE_URL : ANDROID_URL;
    request
      .get(url)
      .query({ id: appId })
      .end((err, res) => {
        if (err || !res.body || !res.body.text) {
          this.setState({ error: true });
        } else {
          this.setState(res.body);
        }
      });
  }

  render() {
    const customChildComponent = this.state.error ? null : (
      <div className="app-icon-container">
        <img
          className={`h_mend-10 ${this.props.imageClassName}`}
          src={this.state.image}
        />
        {this.state.text}
      </div>
    );
    return (
      <Input
        className={`app-store-icon ${this.props.className}`}
        customChildComponent={customChildComponent}
        disabled={true}
        value={this.props.message}
        i13nLabel="App store icon"
        testid={this.props.testid}
      />
    );
  }
}
